import { Box, Tab, Tabs, useTheme } from '@mui/material';
import { TabContext, TabPanel } from '@mui/lab';
import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import Countries from './Countries/Countries';
import GeneralInfo from './GeneralInfo/GeneralInfo';
import usePlanStore from '../../../../store/planStore';
import BackToList from './BackToList/BackToList';
import PlanSummary from './PlanSummary/PlanSummary';
import BackToMediaPlanningGuard from '../../../../router/routes/BackToMediaPlanningGuard';
import AcceptPlanModal from './PlanSummary/AcceptPlanFlow/AcceptPlanModal/AcceptPlanModal';

export default function Plan() {
  const { t } = useTranslation();
  const { activeTab, setActiveTab, isGeneralInfoFilled, isLocked } =
    usePlanStore();
  const theme = useTheme();

  const [showLockedPlanModal, setShowLockedPlanModal] = useState(false);

  useEffect(() => {
    if (isLocked) {
      setShowLockedPlanModal(true);
    }
  }, [isLocked]);

  const lockedSx = {
    pointerEvents: isLocked ? 'none' : 'auto',
    opacity: isLocked ? 0.6 : 1,
  } as const;

  return (
    <Box width="100%" sx={{ backgroundColor: theme.palette.lightGrey.main }}>
      <Box
        sx={{
          fontWeight: 700,
          fontSize: 14,
          borderRadius: '5px',
          mx: '20px',
          mt: '10px',
        }}
      >
        <BackToList />
        <TabContext value={activeTab}>
          <Tabs
            value={activeTab}
            aria-label="Flow Tabs"
            onChange={(event, newValue) => setActiveTab(newValue)}
            sx={{
              justifyContent: 'flex-start',
              display: 'flex',
              borderBottom: '1px solid #bdbdbd',
              height: '1px',
              width: '100%',
              padding: 0,
            }}
          >
            <Tab
              label={t('mediaPlanning.generalInfo')}
              id="vt0"
              value="generalInfo"
            />
            <Tab
              label={t('mediaPlanning.countries')}
              id="vt1"
              value="countries"
              disabled={!isGeneralInfoFilled}
            />
            <Tab
              label={t('mediaPlanning.planSummary')}
              id="vt2"
              value="planSummary"
              disabled={!isGeneralInfoFilled}
            />
          </Tabs>
          <TabPanel value="generalInfo" sx={{ p: 0 }}>
            <Box sx={lockedSx}>
              <GeneralInfo />
            </Box>
          </TabPanel>
          <TabPanel value="countries" sx={{ p: 0 }}>
            <Countries />
          </TabPanel>
          <TabPanel value="planSummary" sx={{ p: 0 }}>
            <Box sx={{ position: 'relative' }}>
              <PlanSummary />
              {isLocked && (
                <Box
                  sx={{
                    position: 'absolute',
                    inset: 0,
                    backgroundColor: 'rgba(255, 255, 255, 0.6)',
                    pointerEvents: 'auto',
                    zIndex: 1,
                  }}
                />
              )}
            </Box>
          </TabPanel>
        </TabContext>
      </Box>
      <AcceptPlanModal
        open={showLockedPlanModal}
        onClose={() => setShowLockedPlanModal(false)}
        onSuccess={() => setShowLockedPlanModal(false)}
        header={t('mediaPlanning.modals.lockedPlan.header')}
        text={t('mediaPlanning.modals.lockedPlan.text')}
        isInformationalOnly
        forceNonDismissible
      />
    </Box>
  );
}
